import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DomHandler } from 'primeng/dom';
import { Editor } from 'primeng/editor';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LocalizationService } from 'src/app/modules/shared/services/localization.service';
import { isStringNullOrWhiteSpace } from 'src/app/util/StringUtil';
import "quill";
import { PageLayoutService } from '../../services/page-layout.service';
import { AdminSelectionEvent } from '../../model/adminSelectionEvent';

@Component({
  selector: 'section-instructions',
  templateUrl: './section-instructions.component.html',
  styleUrls: ['./section-instructions.component.less']
})
export class SectionInstructionsComponent implements AfterViewInit {

  @Input() contentKey = '';
  @Input() admin = false;
  @Input() viewId = '';
  @Input() module = '';
  @Input() permissionLevel = '';
  @Input() permissionValue = '';
  @ViewChild('opInstructions') adminUpdatePanel: OverlayPanel;
  @ViewChild('FieldLabelContentInstr') fieldLabelContent: Editor;
  @ViewChild('toolbar') toolbar: ElementRef;
  @ViewChild('sectionInstr') sectionControl: ElementRef;
  editorContent = '';
  sectionContent = '';
  placeholderActive = false;
  defaultContent = '';
  placeholderContent = $localize`Click here to add instruction text`;
  interactionObserver: IntersectionObserver;
  quill: any;

  constructor(private pageLayoutService: PageLayoutService, private localizationService: LocalizationService,
    private messageService: MessageService) { }

  ngAfterViewInit(): void {
    if (this.admin) {
      this.interactionObserver = new IntersectionObserver(this.onIntersection, {
        root: null,   // default is the viewport
        threshold: .65 // percentage of taregt's visible area. Triggers "onIntersection"
      });

      if (this.contentKey !== '') {
        this.localizationService.getDefaultLabelByKey(this.contentKey).subscribe(resp => this.defaultContent = resp, err => {
          console.log(err);
          this.messageService.add({
            severity: 'error',
            summary: err,
            closable: false
          });
        });
      }

      this.interactionObserver.observe(this.adminUpdatePanel.el.nativeElement);
    }
    this.getContentFromDb();

  }

  getContentFromDb() {
    if (this.contentKey !== '') {
      this.localizationService.getHtmlText(this.contentKey, this.module).subscribe(resp => {
        if ((isStringNullOrWhiteSpace(resp)) && this.admin) {
          this.sectionContent = null;
          this.editorContent = null;
          this.placeholderActive = true;
        } else {
          this.sectionContent = resp;
          this.editorContent = resp;
          this.placeholderActive = false;
        }
      }, err => {
        console.log(err);
        this.messageService.add({
          severity: 'error',
          summary: err,
          closable: false
        });
      });
    }
  }

  adminSelection(ev: Event) {
    if (this.admin) {

      this.quill = this.fieldLabelContent.getQuill();
      if(this.quill){
        let toolbar = this.quill.getModule('toolbar');
        toolbar.addHandler('image', function() {
          const value = prompt('Enter Image URL:');
          if (value !== null && value !== '') {
            const range = this.quill.getSelection();
            this.quill.insertEmbed(range.index, 'image', value);
            this.quill.formatText(range.index, range.index + 1, 'alt', 'Image');
          }
        });
      }

      const hostedDiv = this.sectionControl.nativeElement;
      hostedDiv.insertAdjacentElement('afterend', this.adminUpdatePanel.el.nativeElement);
      if (!this.adminUpdatePanel.container) {
        this.adminUpdatePanel.container = this.adminUpdatePanel.el.nativeElement.firstElementChild;
      }
      this.adminUpdatePanel.show(ev, hostedDiv);

      if (this.adminUpdatePanel.el.nativeElement && this.adminUpdatePanel.el.nativeElement.classList.contains('admin-panel-flip')) {
        if (!this.adminUpdatePanel.container) {
          this.adminUpdatePanel.container = this.adminUpdatePanel.el.nativeElement.firstElementChild;
        }

        if(this.adminUpdatePanel.container){
          DomHandler.addClass(this.adminUpdatePanel.container, 'p-overlaypanel-flipped');
          const elementDimensions = this.adminUpdatePanel.container.offsetParent ?
          { width: this.adminUpdatePanel.container.offsetWidth, height: this.adminUpdatePanel.container.offsetHeight } :
          DomHandler.getHiddenElementDimensions(this.adminUpdatePanel.container);

        let top = hostedDiv.getBoundingClientRect().top + DomHandler.getWindowScrollTop() - elementDimensions.height;
        this.adminUpdatePanel.container.style.transformOrigin = 'bottom';
        if (top < 0) {
          top = DomHandler.getWindowScrollTop();
        }

        }

        if(this.adminUpdatePanel.container){
          this.adminUpdatePanel.container.style.top = top + 'px';
        }
      } else {
        this.adminUpdatePanel.align();
      }
    }
  }

  // callback is called on intersection change
  onIntersection(entries: Array<IntersectionObserverEntry>, opts: IntersectionObserver) {
    entries.forEach(entry =>
      entry.target.classList.toggle('admin-panel-flip', entry.isIntersecting)
    );
  }

  submitAdminContentUpdate() {
    //Check for this html code when no text is entered but settings like header etc are selected
    const innerText = this.quill.root.innerText.replace('\ufeff', '');
    const isImageAdded = this.quill.root.innerHTML?.trim().includes('img');
    const editorhtml = ((innerText.trim() === '') && !isImageAdded) ? '' : this.quill.root.innerHTML?.trim();
    this.pageLayoutService.saveUpdatedSection(editorhtml
        , this.contentKey, this.viewId, this.module, this.permissionLevel, this.permissionValue)
        .subscribe(res => {
          this.adminUpdatePanel.hide();
          this.getContentFromDb();
        });

  }

}
